export default "__VITE_ASSET__17fe145b__"